import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { memoize } from './memoize';
import { getAvailableIndustriesRpc } from '../../__generated__/chirp/com/hubspot/get/to/know/me/data/rpc/UtilsRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: noAuthApiClient
});
export const fetchIndustriesAvailable = memoize((options = {}) => {
  return rpcClient.call(getAvailableIndustriesRpc, Object.assign({
    request: {},
    timeout: 5000
  }, options));
}, options => JSON.stringify(options));